import { render } from "./LearningCentre.vue?vue&type=template&id=6f9b0112&scoped=true"
import script from "./LearningCentre.vue?vue&type=script&lang=js"
export * from "./LearningCentre.vue?vue&type=script&lang=js"

import "./LearningCentre.vue?vue&type=style&index=0&id=6f9b0112&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f9b0112"]])

export default __exports__